import { render, staticRenderFns } from "./LuNoteTypeGrid.vue?vue&type=template&id=658fb8e2&"
import script from "./LuNoteTypeGrid.vue?vue&type=script&lang=js&"
export * from "./LuNoteTypeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports